import { AuthProvider } from "react-admin";
import { AxiosError } from "axios";
import {
  axiosInstance,
  clearTokens,
  getAccessToken,
  isAccessTokenExpired,
  refreshTokens,
  setTokens,
} from "./axiosConfig";

const authProvider: AuthProvider = {
  login: ({ email, password }) => {
    return axiosInstance
      .post("/api/v1/auth/login", { email, password })
      .then((response) => {
        setTokens(response.data.accessToken, response.data.refreshToken);
      })
      .catch((error: AxiosError) => {
        console.warn(error);

        return Promise.reject(error.response?.data);
      });
  },

  logout: () => {
    return axiosInstance
      .get("/api/v1/auth/logout")
      .then(() => {
        clearTokens();
      })
      .catch((error) => {
        console.warn(error);
      });
  },
  checkError: (error: AxiosError) => {
    if (error.response?.status !== 401 && error.response?.status !== 403) {
      return Promise.resolve();
    }

    // Shares the in-flight refresh (if any) with the response interceptor
    // in axiosConfig.ts instead of firing an independent /refresh-token
    // call - see refreshTokens's doc comment for why that used to cause
    // spurious logouts under concurrent requests.
    return refreshTokens()
      .then(() => {})
      .catch((refreshError) => {
        clearTokens();
        console.warn(refreshError);
        return Promise.reject({ redirectTo: "/login" });
      });
  },
  async checkAuth() {
    if (!getAccessToken()) {
      throw new Error("Not authenticated");
    }

    // Only hit the network when the token is actually due to expire,
    // instead of rotating it on every navigation (react-admin calls
    // checkAuth on mount and on every protected-route transition) - that
    // used to compete with any in-flight request's own refresh-on-401.
    if (!isAccessTokenExpired()) {
      return;
    }

    return refreshTokens()
      .then(() => {})
      .catch((error) => {
        clearTokens();
        console.warn(error);
        return Promise.reject({ redirectTo: "/login" });
      });
  },
  getPermissions: () => {
    if (getAccessToken()) {
      return Promise.resolve("authorized");
    }
    return Promise.resolve("unauthorized");
  },
};

export default authProvider;
